export const insertToArray = <T>(arr: Array<T> | T[], index: number, insertElement: T): T[] => {
  if (!arr) {
    return [];
  }

  return [...arr.slice(0, index), insertElement, ...arr.slice(index)];
};
